<template>
  <div class="video-card h-[437px]" :class="{ 'flex-row-reverse': revert }">
    <div class="video-content flex flex-col relative">
      <div>
        <h2 class="title">{{ data.title }}</h2>
        <p v-if="data.desc" class="desc mx-auto my-0">{{ data.desc }}</p>
        <div v-if="data.sub_title" class="sub-title mx-auto mb-[22px]">
          {{ data.sub_title }}
        </div>
        <ul v-if="displayList.length > 0" class="detail">
          <li v-for="(item, idx) in displayList" :key="idx" class="detail-item flex items-start">
            <iconpark-icon
              name="check-gfj499op"
              class="text-[var(--purple-6)] mt-[2px] mr-[12px]"
            ></iconpark-icon>
            <p class="detail-title">{{ item.title }}</p>
          </li>
        </ul>
      </div>
      <div class="flex justify-start absolute bottom-[37px] left-[50px]">
        <CreateBtn :template="data.template" @create-work="handleCreateWork" />
      </div>
    </div>
    <div class="media-player">
      <Media
        :template="data.template"
        :type="getVideoType(data.template)"
        :hover-video="data.template.preview_video"
      >
        <template #before>
          <div class="absolute top-[12px] left-[12px] z-10 flex gap-[12px]">
            <XTag v-if="data?.template?.is_hot" :type="'hot'" />
            <XTag v-if="data?.template?.is_new" :type="'new'" />
          </div>
        </template>
      </Media>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Media from './media.vue';
import type { Template } from '~/api/interface';
import type { ScenariosConfigDataCard } from '~/api/interface/scenarios';
import CreateBtn from '../create-btn.vue';
import { useTemplate } from '~/features/template/components/info';

interface CardProps {
  data: ScenariosConfigDataCard;
  revert?: boolean;
}

const props = defineProps<CardProps>();

const displayList = computed(() => props.data.list as unknown as Template[]);

const getVideoType = (template: Template) => {
  if (template.resolution === '1920x1080') {
    return 'horizontal';
  }
  return 'vertical';
};

const handleCreateWork = () => {
  useTemplate({ ...props.data.template, id: props.data.template?.id });
};
</script>
<style lang="scss" scoped>
.video-card {
  display: flex;
  width: 100%;
  height: 437px;
  border-radius: 20px;
  overflow: hidden;

  background: linear-gradient(121.97deg, #f1f6ff 2.39%, #f6f8ff 72.66%);

  .media-player {
    background: linear-gradient(110.68deg, #d3e0ff 0%, #e9e8ff 100%);
    position: relative;
    width: 700px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &:deep(video) {
      border-radius: 12px;
    }
  }
  .fire {
    position: absolute;
    left: 10px;
    top: 10px;
    color: var(--error-6);
    z-index: 10;
  }
  .video-content {
    width: 500px;
    padding: 44px 50px;

    h2 {
      margin: 0;
    }
    .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
      color: var(--text-1);
      margin: 0 auto 12px;
    }

    .desc {
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      color: var(--text-1-60);
      margin-bottom: 40px;
    }

    .sub-title {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
      color: var(--text-1);
      margin-bottom: 15px;
    }

    .detail-item {
      margin-bottom: 16px;
      .detail-title {
        font-size: 14px;
        line-height: 20px;
        color: var(--text-1);
        display: flex;
        margin: 0;
        align-items: center;
      }
      .detail-content {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin: 12px auto 20px;
        color: var(--text-1-60);
      }
    }
  }
}
</style>
